import { render } from "./couponLoad.vue?vue&type=template&id=46eac73d&scoped=true&ts=true"
import script from "./couponLoad.vue?vue&type=script&lang=ts"
export * from "./couponLoad.vue?vue&type=script&lang=ts"

import "./couponLoad.vue?vue&type=style&index=0&id=46eac73d&scoped=true&lang=css"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46eac73d"]])

export default __exports__